import { Form } from 'react-router'
import { HoneypotInputs } from 'remix-utils/honeypot/react'

import { ErrorList } from '#app/components/form/error-list.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { Card } from '#app/components/ui/card.tsx'
import { Input } from '#app/components/ui/input.tsx'
import { Label } from '#app/components/ui/label.tsx'

import { type LoginFormViewModel } from '#app/routes/_auth+/login.controller.tsx'

export function LoginFormView({ view }: { view: LoginFormViewModel }) {
	return (
		<Card className="mx-auto w-full max-w-md">
			<Form method="POST" {...view.formProps} className="p-6 md:p-8">
				<HoneypotInputs />
				<div className="flex flex-col gap-6">
					<div className="space-y-1 text-center">
						<h1 className="text-lg font-semibold">Welcome back</h1>
						<p className="text-muted-foreground text-sm">
							Login to your Lydra account
						</p>
					</div>
					<div className="grid gap-2 text-left">
						<Label htmlFor={view.email.inputProps.id}>Email</Label>
						<Input
							required
							autoFocus
							autoComplete="email"
							{...view.email.inputProps}
						/>
						{view.email.errors.length ? (
							<div className="text-xs text-red-500">{view.email.errors[0]}</div>
						) : null}
						<Button disabled={view.isPending} type="submit" className="w-full">
							{view.isPending ? 'Sending…' : 'Send magic link'}
						</Button>
						<ErrorList errors={view.formErrors} />
						{view.devVerifyUrl ? (
							<div className="text-center">
								<a
									href={view.devVerifyUrl}
									className="text-sm underline underline-offset-4"
								>
									Dev: Open sign-in link
								</a>
							</div>
						) : null}
					</div>
					<input {...view.redirectInputProps} />
					<div className="text-center text-sm">
						Don&apos;t have an account?{' '}
						<a
							href="https://calendly.com/mo-curigenx/30min"
							className="underline underline-offset-4"
						>
							Book a demo
						</a>
					</div>
				</div>
			</Form>
		</Card>
	)
}
